module.exports = __webpack_public_path__ + "img/white-tray-arrow-down.d4a966f3.svg";